export default {
  isOpen: false,
  currentRecipeId: "",
};
